module.exports = __webpack_public_path__ + "static/media/inside-right-seats.91b90374.svg";